module.exports = __webpack_public_path__ + "static/media/BurpSuite-logo.f60b5261.png";